import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { Marker, StyledAlertIcon } from "pro-features/components/Chart/src/configs/plotLines/ChangeBellWithoutTooltip";
import { translate } from "app/filters/i18nFilter";
import styled from "styled-components";

const { carbon, orange } = colorsPalettes;

const Title = styled.span`
    ${setFontVariant("body2", carbon[300])}
`;

const Container = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: ${orange[100]};
    padding: 8px 12px;
    border-radius: 4px;
`;

export const CustomBanner = () => {
    return (
        <Container data-automation="custom-banner-container">
            <Marker>
                <StyledAlertIcon iconName="alerts" />
            </Marker>
            <Title>{translate("segments.analysis.traffic.and.engagement.change.algo.tooltip")}</Title>
        </Container>
    );
};
